jQuery(document).ready(function () {
  jQuery('.js-buy-button').on('click', function() {
    var $menu = jQuery(this).siblings('.buy-menu');
    $menu.toggleClass('is-open');
    if ($menu.hasClass('is-open')) {
      jQuery(this).addClass('open-menu');
    } else {
      jQuery(this).removeClass('open-menu');
    }
  });
});